export const BRANDS = {
  curology: 'curology',
  agency: 'agency',
} as const;

export type Brand = valueof<typeof BRANDS>;
export const BRAND_IDS = {
  curology: 1,
  agency: 2,
} as const satisfies Record<Brand, number>;

export type BrandId = valueof<typeof BRAND_IDS>;
